import React, { useEffect, useState } from "react"
import styled from "styled-components"
import BackIconPNG from "../../../assets/Icons/SingleAlbum/back.png"
import UnderLine from "../../atoms/Login/UnderLine"
import ShareButton from "../../atoms/Dashboard/ShareCode/ShareButtonModal"
import QRCode from "qrcode.react"
import CopyPNG from "../../../assets/Icons/ShareCode/copy.svg"
import DownloadSVG from "../../../assets/Icons/Download.svg"
import WHATSAPPSVG from "../../../assets/Icons/Whatsapp.svg"
import { useNavigate, useParams } from "react-router-dom"
import { showSuccessToast, showErrorToast } from "../../atoms/Utlis/Toast"
import { getWhiteLableObject } from "../../../config/whitelable"
import { uploadToCloudinary1 } from "../../../Redux/ApiCalls/Cloudinary"
import { useAppSelector } from "../../../Redux/Hooks"
import { useDevmode } from "../../../hooks/useDevmode"
import { setOrGetQrImageOfAlbumAPI } from "../../../Redux/ApiCalls/Dashboard/AlbumAPI"
import { IMAGE_CDN } from "../../../config/config"
import { trackClarityEvent } from "../../../analytics/ClarityAnalytics"
import { CLARITY_EVENTS } from "../../../analytics/EventTypes"
import apiCall from "../../../Redux/ApiCalls/AuthorizedApi"
import LoadingDots from "../../atoms/Utlis/LoadinDots"

const MAHAVEER_FILMS_PORTAL_URL =
  "https://mahaveerfilms.portal.kwikmemories.com/"

const withMahaveerPortalLink = (message: string) => {
  if (getWhiteLableObject().key !== "MahaveerFilms") return message
  return `Portal: ${MAHAVEER_FILMS_PORTAL_URL}\n${message.trim()}`
}

const HeaderWrapper = styled.div`
  padding: 20px 24px 0 24px;
  width: 100%;
  box-sizing: border-box;
`

const ShareCodeContainer = styled.div`
  padding: 20px 28px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 16px 16px 16px 0;
  }
`

const ShareCodeHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 20px;
  margin-bottom: 4px;
`

const BackIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`

const Text1 = styled.p`
  font-family: Urbanist, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`

const Text2 = styled.p`
  font-family: Urbanist, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #171717;
`

const MainContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  gap: 36px;
  padding-top: 16px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    gap: 28px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 28px;
    padding-top: 12px;
  }
`

const QrCodeWrapper = styled.div`
  width: 100%;
  max-width: 380px;
  aspect-ratio: 1/1;
  padding: 28px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 48px;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 20px;
    margin-bottom: 36px;
  }
`

const EventSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: 400px;
`

const EventCodeLabel = styled.p`
  font-family: Urbanist, sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin: 0;
  background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`

const CodeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  max-width: 280px;
  padding: 10px 14px;
  background: #f5f5f5;
  border-radius: 12px;
`

const EventCodeText = styled.p`
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #171717;
  margin: 0;
  word-break: break-all;
  flex: 1;
`

const CopyIcon = styled.img`
  height: 20px;
  width: 20px;
  cursor: pointer;
  flex-shrink: 0;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`

const CopyButton = styled.button`
  width: 100%;
  max-width: 280px;
  cursor: pointer;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
  font-family: Urbanist, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: white;
  border: none;
  transition: opacity 0.2s ease, transform 0.1s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`

const Spinner = styled.svg`
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

const ShareToCustomerButton = styled.button`
  width: 100%;
  max-width: 280px;
  cursor: pointer;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(144.01deg, #25d366 0%, #128c7e 100%);
  font-family: Urbanist, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: white;
  border: none;
  transition: opacity 0.2s ease, transform 0.1s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

const UnderlineContainer = styled.div`
  width: 100%;
  max-width: 280px;
  display: flex;
  justify-content: center;
  margin: 4px 0;
`

const Banner = styled.div`
  width: 100%;
  padding: 16px 20px;
  margin-bottom: 24px;
  background: linear-gradient(135deg, rgba(255, 201, 81, 0.12) 0%, rgba(201, 77, 170, 0.12) 100%);
  border-radius: 16px;
  border: 1px solid rgba(255, 201, 81, 0.3);
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;

  @media (max-width: 768px) {
    padding: 14px 16px;
    margin-bottom: 20px;
  }
`

const BannerText = styled.p`
  font-family: Urbanist, sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #171717;
  margin: 0;
  line-height: 1.4;
  text-align: center;
  width: 100%;
`

const BannerActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`

const BannerRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
`

const BannerRowLabel = styled.span`
  font-family: Urbanist, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #555;
`

const BannerRowLabelWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
`

const BannerRowQr = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

  canvas,
  svg {
    width: 100% !important;
    height: 100% !important;
    max-width: 100px;
    max-height: 100px;
  }
`

const BannerShareButton = styled.button`
  cursor: pointer;
  height: 44px;
  padding: 0 20px;
  border-radius: 12px;
  background: linear-gradient(144.01deg, #25d366 0%, #128c7e 100%);
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: white;
  border: none;
  transition: opacity 0.2s ease, transform 0.1s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`

const BannerDownloadButton = styled.button`
  cursor: pointer;
  height: 44px;
  padding: 0 20px;
  border-radius: 12px;
  background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%);
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: white;
  border: none;
  transition: opacity 0.2s ease, transform 0.1s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`

const BannerContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`

const EventCodeTitle = styled.div`
  text-align:center;
  font-weight:500;
`

const ShareCodePage: React.FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  const [code, setCode] = useState("")
  const [fullAccessCode, setFullAccessCode] = useState("")
  const [sendingGuestToCustomer, setSendingGuestToCustomer] = useState(false)
  const [sendingFullToCustomer, setSendingFullToCustomer] = useState(false)
  const { business } = useAppSelector((state) => state.auth)
  const { currentAlbum } = useAppSelector((state) => state.album)
  const isDevMode = useDevmode()
  console.log("isDevMode", isDevMode)
  const canvasToFile = (
    canvas: HTMLCanvasElement,
    filename: string
  ): Promise<File> => {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) return
        resolve(new File([blob], filename, { type: "image/png" }))
      }, "image/png")
    })
  }

  const getQrImageUrl = async (code: string, access: string): Promise<any> => {
    const canvas = document.getElementById(`qr-${code}`) as HTMLCanvasElement
    if (!canvas) return null

    const file = await canvasToFile(canvas, `${code}.png`)
    if (currentAlbum) {
      const formData = new FormData()
      formData.append("type", access)
      formData.append("project_id", currentAlbum.id.toString())
      formData.append("qr_image", file)
      const res = await setOrGetQrImageOfAlbumAPI(formData)
      return res?.qr_url ? IMAGE_CDN + "/" + res?.qr_url : null
    }

    return null
  }

  const getQrBase64 = (code: string) => {
    const canvas = document.getElementById(`qr-${code}`) as HTMLCanvasElement
    if (!canvas) return null
    return canvas.toDataURL("image/png")
  }

  useEffect(() => {
    if (params.code) setCode(params.code)
    if (params.fullAccessCode) setFullAccessCode(params.fullAccessCode)
  }, [])

  const handleCopy = (text: string, codeType?: string) => {
    navigator.clipboard.writeText(text)
    showSuccessToast("Code copied to clipboard.")
    trackClarityEvent(CLARITY_EVENTS.ALBUM_CODE_SHARED, {
      code: text,
      code_type: codeType || "guest",
      project_id: currentAlbum?.id,
      action: "copy",
    })
  }
  const qrLink = (eventCode: string) => {
    const encodedCode = encodeURIComponent(eventCode)
    switch (getWhiteLableObject().key) {
      case "LPS":
        return `https://lps-group.onelink.me/T9vK?af_xp=custom&pid=album-redeem&af_dp=https%3A%2F%2Flps.admin.kwikmedia.in%2Falbum-redeem%3Fcode%3D${eventCode}`
      case "Dhiyoyo":
       return `https://deep.limelink.org/dhiyoyo-album?code=${encodedCode}&deep_link_sub1=${encodedCode}&sub1=${encodedCode}`
      case "AshokPhotography":
        return `https://ashok-photography.onelink.me/92Sn?af_xp=custom&pid=album-redeem&af_dp=ashokphotography%3A%2F%2Fhttps%3A%2F%2Fkwikmemories.com%2Falbum-redeem%3Fcode%3D${eventCode}`
      case "BollywoodStudios":
        return `https://deep.limelink.org/bollywoodstudio-album?code=${encodedCode}&deep_link_sub1=${encodedCode}&sub1=${encodedCode}`
      case "default":
      case "MahaveerFilms":
      default:
        return `https://deep.limelink.org/album?code=${encodedCode}&deep_link_sub1=${encodedCode}&sub1=${encodedCode}`
    }
  }

  const qrLinkV2 = (eventCode: string) => {
    return `https://${getWhiteLableObject().domain}/extra/deeplink?code=${eventCode}&business_id=${business?.id}`
  }

  const handleShareToCustomer = async (codeType: "guest" | "full") => {
    if (!currentAlbum?.customer_mobile) {
      showErrorToast("Customer phone number not available")
      return
    }

    const selectedCode = codeType === "guest" ? code : fullAccessCode
    if (!selectedCode) {
      showErrorToast("Code not available")
      return
    }

    // Set the appropriate loading state
    if (codeType === "guest") {
      setSendingGuestToCustomer(true)
    } else {
      setSendingFullToCustomer(true)
    }

    try {
      const qrUrl = await getQrImageUrl(selectedCode, codeType)

      if (!qrUrl) {
        showErrorToast("Failed to generate QR image")
        if (codeType === "guest") {
          setSendingGuestToCustomer(false)
        } else {
          setSendingFullToCustomer(false)
        }
        return
      }

      const response = await apiCall({
        method: "POST",
        url: "/project/api/send-whatsapp-message/",
        data: {
          to: [`+91${currentAlbum.customer_mobile}`],
          header_image: qrUrl,
          body_1: selectedCode,
          body_2: currentAlbum?.name || ""
        }
      })

      showSuccessToast("QR code sent to customer via WhatsApp!")
      trackClarityEvent(CLARITY_EVENTS.ALBUM_CODE_SHARED, {
        code: selectedCode,
        code_type: codeType,
        project_id: currentAlbum?.id,
        action: "share",
        share_method: "whatsapp_customer",
        recipient: currentAlbum.customer_mobile,
      })
    } catch (error: any) {
      console.error('Error sending WhatsApp message to customer:', error)
      showErrorToast(error?.response?.data?.message || "Failed to send QR code to customer")
    } finally {
      if (codeType === "guest") {
        setSendingGuestToCustomer(false)
      } else {
        setSendingFullToCustomer(false)
      }
    }
  }

  const downloadQrAsFile = (canvasId: string, filename: string) => {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement
    if (!canvas) return
    const link = document.createElement("a")
    link.download = filename
    link.href = canvas.toDataURL("image/png")
    link.click()
  }

  const handleBannerShareGuest = async () => {
    if (!code) return
    const guestQrUrl = await getQrImageUrl(code, "guest")
    const message = withMahaveerPortalLink(
      `Guest Access QR: ${guestQrUrl || "—"}\nGuest Redeem Code: ${code}`
    )
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank", "noopener,noreferrer")
    trackClarityEvent(CLARITY_EVENTS.ALBUM_CODE_SHARED, {
      code,
      code_type: "guest",
      project_id: currentAlbum?.id,
      action: "share",
      share_method: "whatsapp_banner",
    })
  }

  const handleBannerShareFull = async () => {
    if (!fullAccessCode) return
    const fullQrUrl = await getQrImageUrl(fullAccessCode, "full")
    const message = withMahaveerPortalLink(
      `Full Access QR: ${fullQrUrl || "—"}\nFull Access Code: ${fullAccessCode}`
    )
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank", "noopener,noreferrer")
    trackClarityEvent(CLARITY_EVENTS.ALBUM_CODE_SHARED, {
      code: fullAccessCode,
      code_type: "full",
      project_id: currentAlbum?.id,
      action: "share",
      share_method: "whatsapp_banner",
    })
  }

  const handleBannerDownloadGuest = () => {
    if (!code) return
    downloadQrAsFile(`qr-${code}`, `guest-access-qr-${code}.png`)
    showSuccessToast("Guest Access QR downloaded.")
    trackClarityEvent(CLARITY_EVENTS.ALBUM_CODE_SHARED, {
      code,
      code_type: "guest",
      project_id: currentAlbum?.id,
      action: "download",
      share_method: "banner",
    })
  }

  const handleBannerDownloadFull = () => {
    if (!fullAccessCode) return
    downloadQrAsFile(`qr-${fullAccessCode}`, `full-access-qr-${fullAccessCode}.png`)
    showSuccessToast("Full Access QR downloaded.")
    trackClarityEvent(CLARITY_EVENTS.ALBUM_CODE_SHARED, {
      code: fullAccessCode,
      code_type: "full",
      project_id: currentAlbum?.id,
      action: "download",
      share_method: "banner",
    })
  }

  return (
    <>
      <HeaderWrapper>
        <ShareCodeHeader>
          <BackIcon src={BackIconPNG} onClick={() => navigate(-1)} />
          <Text1 onClick={() => navigate("/dashboard/")}>Dashboard</Text1>
          <Text2>Generate Event Code</Text2>
        </ShareCodeHeader>
      </HeaderWrapper>
      <ShareCodeContainer style={{ paddingTop: 0 }}>
        <MainContainer>
          <Banner>
            <BannerText>
              To download the QR code for banner and share.
            </BannerText>
            <BannerContainer>
              <BannerRow>
                <BannerRowLabelWrap>
                  <BannerRowLabel>Guest Access QR</BannerRowLabel>
                  <BannerRowQr>
                    <QRCode
                      id={`qr-${code}`}
                      value={isDevMode ? qrLinkV2(code) : qrLink(code)}
                      size={240}
                    />
                  </BannerRowQr>
                </BannerRowLabelWrap>
                <BannerActions>
                  <BannerShareButton onClick={handleBannerShareGuest}>
                    <img src={WHATSAPPSVG} width={18} height={18} />
                    Share
                  </BannerShareButton>
                  <BannerDownloadButton onClick={handleBannerDownloadGuest}>
                    <img src={DownloadSVG} width={18} height={18} />
                    Download
                  </BannerDownloadButton>
                </BannerActions>
              </BannerRow>
              {fullAccessCode && (
                <BannerRow>
                  <BannerRowLabelWrap>
                    <BannerRowLabel>Full Access QR</BannerRowLabel>
                    <BannerRowQr>
                      <QRCode
                        id={`qr-${fullAccessCode}`}
                        value={
                          isDevMode
                            ? qrLinkV2(fullAccessCode)
                            : qrLink(fullAccessCode)
                        }
                        size={240}
                      />
                    </BannerRowQr>
                  </BannerRowLabelWrap>
                  <BannerActions>
                    <BannerShareButton onClick={handleBannerShareFull}>
                      <img src={WHATSAPPSVG} width={18} height={18} />
                      Share
                    </BannerShareButton>
                    <BannerDownloadButton onClick={handleBannerDownloadFull}>
                      <img src={DownloadSVG} width={18} height={18} />
                      Download
                    </BannerDownloadButton>
                  </BannerActions>
                </BannerRow>
              )}
            </BannerContainer>

          </Banner>
          {/* Guest Redeem QR */}
          <EventSection>
            <div>
              <EventCodeTitle>To share the QR code to Customers.</EventCodeTitle>
              <EventCodeLabel>Guest Access QR</EventCodeLabel>
            </div>
            <QrCodeWrapper>
              <QRCode
                id={`qr-${code}`}
                value={isDevMode ? qrLinkV2(code) : qrLink(code)}
                size={240}
              />
              {/* <ShareButton shareUrl={`Guest Redeem Code: ${code}`} /> */}
              <ShareButton
                shareUrl={`Guest Redeem Code: ${code}`}
                code={code}
                onShare={async () => {
                  const qrUrl = await getQrImageUrl(code, "guest")
                  trackClarityEvent(CLARITY_EVENTS.ALBUM_CODE_SHARED, {
                    code: code,
                    code_type: "guest",
                    project_id: currentAlbum?.id,
                    action: "share",
                    share_method: "qr",
                  })
                  return {
                    message: withMahaveerPortalLink(`
                View Album: ${qrLink(code)}
                Guest Redeem Code: ${code}
                `),
                    url: qrUrl,
                  }
                }}
              />
            </QrCodeWrapper>
            <CodeContainer>
              <EventCodeText>{code}</EventCodeText>
              <CopyIcon src={CopyPNG} onClick={() => handleCopy(code, "guest")} />
            </CodeContainer>
            <UnderlineContainer>
              <UnderLine width={100} isPercent={true} />
            </UnderlineContainer>
            <CopyButton onClick={() => handleCopy(code, "guest")}>
              Copy Guest Code
            </CopyButton>
            {currentAlbum?.customer_mobile && (
              <ShareToCustomerButton
                onClick={() => handleShareToCustomer("guest")}
                disabled={sendingGuestToCustomer}
              >
                {sendingGuestToCustomer ? (
                  <>
                    <Spinner
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeOpacity="0.25"
                      />
                      <path
                        fill="currentColor"
                        fillOpacity="0.75"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      />
                    </Spinner>
                    <span>Sending...</span>
                  </>
                ) : (
                  <>
                    <img src={WHATSAPPSVG} width={20} height={20} />
                    Share QR to Customer
                  </>
                )}
              </ShareToCustomerButton>
            )}
          </EventSection>

          {/* Full Access QR */}
          {fullAccessCode && (
            <EventSection>
              <div>
                <EventCodeTitle>To share the QR code to Customers.</EventCodeTitle>
                <EventCodeLabel>Full Access QR</EventCodeLabel>
              </div>
              <QrCodeWrapper>
                <QRCode
                  id={`qr-${fullAccessCode}`}
                  value={
                    isDevMode ? qrLinkV2(fullAccessCode) : qrLink(fullAccessCode)
                  }
                  size={240}
                />
                <ShareButton
                  shareUrl={`Full Access Code: ${fullAccessCode}`}
                  code={fullAccessCode}
                  onShare={async () => {
                    const qrUrl = await getQrImageUrl(fullAccessCode, "full")
                    trackClarityEvent(CLARITY_EVENTS.ALBUM_CODE_SHARED, {
                      code: fullAccessCode,
                      code_type: "full",
                      project_id: currentAlbum?.id,
                      action: "share",
                      share_method: "qr",
                    })
                    return {
                      message: withMahaveerPortalLink(`
                  View Album: ${qrLink(fullAccessCode)}
                  Full Access Code: ${fullAccessCode}
                  `),
                      url: qrUrl,
                    }
                  }}
                />
              </QrCodeWrapper>
              <CodeContainer>
                <EventCodeText>{fullAccessCode}</EventCodeText>
                <CopyIcon
                  src={CopyPNG}
                  onClick={() => handleCopy(fullAccessCode, "full_access")}
                />
              </CodeContainer>
              <UnderlineContainer>
                <UnderLine width={100} isPercent={true} />
              </UnderlineContainer>
              <CopyButton onClick={() => handleCopy(fullAccessCode, "full_access")}>
                Copy Full Access Code
              </CopyButton>
              {currentAlbum?.customer_mobile && (
                <ShareToCustomerButton
                  onClick={() => handleShareToCustomer("full")}
                  disabled={sendingFullToCustomer}
                >
                  {sendingFullToCustomer ? (
                    <>
                      <Spinner
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                          strokeOpacity="0.25"
                        />
                        <path
                          fill="currentColor"
                          fillOpacity="0.75"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </Spinner>
                      <span>Sending...</span>
                    </>
                  ) : (
                    <>
                      <img src={WHATSAPPSVG} width={20} height={20} />
                      Share QR to Customer
                    </>
                  )}
                </ShareToCustomerButton>
              )}
            </EventSection>
          )}
        </MainContainer>
      </ShareCodeContainer>
    </>
  )
}

export default ShareCodePage
